import React from "react";
import classNames from "classnames";
import { Popup } from "semantic-ui-react";
import { EmailLogStatus } from "constants/enums";

const StatusDescriptions = {
  [EmailLogStatus.Created]:
    "The email has been created and is waiting to be sent",
  [EmailLogStatus.Sent]: "The email has been sent",
  [EmailLogStatus.Delivered]:
    "The email was delivered to the recipient's mail server",
  [EmailLogStatus.Opened]: "The recipient opened the email",
  [EmailLogStatus.Clicked]: "The recipient clicked a link in the email",
  [EmailLogStatus.Rejected]:
    "The email was rejected before it could be sent, e.g. an invalid email address",
  [EmailLogStatus.Bounced]: "The email could not be delivered to the recipient",
  [EmailLogStatus.Blocked]:
    "The recipient's mail server temporarily blocked the email",
  [EmailLogStatus.SpamReported]: "The recipient reported the email as spam",
};

const EmailStatusLabel = ({ status, statusDescription, statusReason }) =>
  !status ? null : (
    <Popup
      inverted
      content={
        <div>
          {StatusDescriptions[status] ?? status}
          {statusReason && (
            <React.Fragment>
              <br />
              <strong>Reason</strong>
              <br />
              {statusReason}
            </React.Fragment>
          )}
        </div>
      }
      trigger={
        <div className={classNames("email-status-label", status.toLowerCase())}>
          {statusDescription ?? status}
        </div>
      }
    />
  );

export default EmailStatusLabel;
